export default "__VITE_ASSET__d564b04f__"